<dx-toolbar [width]="237" class="field-editor-map-toolbar">
  <dxi-item location="before" widget="dxButton">
    <div *dxTemplate>
      <div class="flex flex-row mr-4 items-center">
        <!--<span class="block mr-2 text-sm font-medium">Mode: </span>-->
        <dx-button-group
          [items]="viewModes"
          keyExpr="mode"
          stylingMode="text"
          [selectedItemKeys]="[viewMode]"
          (onItemClick)="itemClick($event)">
        </dx-button-group>
      </div>
    </div>
  </dxi-item>
</dx-toolbar>
